/**
 * Opay cart checkout: one document-level delegate for summary + drawer buttons.
 * Load once from layout (see snippets/opay-checkout-init.liquid). Inline scripts
 * inside morphed/replaced section HTML often do not run — this file always does.
 */
(function () {
  if (document.documentElement.dataset.opayCheckoutBound) return;
  document.documentElement.dataset.opayCheckoutBound = '1';

  function opayResolveCheckoutBtn(e, selector) {
    var t = e.target;
    if (t && typeof t.closest === 'function') {
      var byClosest = t.closest(selector);
      if (byClosest) return byClosest;
    }
    var path = typeof e.composedPath === 'function' ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.nodeType === 1 && typeof n.matches === 'function' && n.matches(selector)) {
        return n;
      }
    }
    return null;
  }

  async function opayRunCheckout() {
    var cartRes = await fetch('/cart.js');
    var cart = await cartRes.json();
    if (!cart.items || !cart.items.length) {
      alert('Your cart is empty. Add a product and try again.');
      return;
    }
    var syncRes = await fetch('/apps/opay/cart-sync', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: cart.items,
        discount_codes: cart.discount_codes || [],
      }),
    });
    var data = await syncRes.json().catch(function () {
      return {};
    });
    if (!syncRes.ok) {
      alert(data.error || 'Could not start Opay checkout. Try again.');
      return;
    }
    if (data.redirect) {
      window.location.href = data.redirect;
      return;
    }
    alert('Could not start Opay checkout. Try again.');
  }

  document.addEventListener(
    'click',
    function (e) {
      var summary = opayResolveCheckoutBtn(e, '[data-opay-checkout-summary]');
      var drawer = summary ? null : opayResolveCheckoutBtn(e, '[data-opay-checkout-drawer]');
      var btn = summary || drawer;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      opayRunCheckout().catch(function (err) {
        console.error(err);
        alert('Could not start Opay checkout.');
      });
    },
    true
  );
})();
